import React, { useEffect } from 'react'
import { useRouter } from 'next/router'

import { ROUTES } from '@/constants'
import OverviewPage from '@/pages/overview'

export default function RedirectToInitial() {
  const router = useRouter()

  useEffect(() => {
    router.replace(ROUTES.overview)
  }, [])

  return <OverviewPage />
}
